<div class="product-slider-container">
  <div class="content">
    <div class="headline">
      <kion-headline-tag [title]="component.title" [titleSize]="component.titleSize"></kion-headline-tag>
    </div>
    <kion-product-slider [products]="products$ | async"></kion-product-slider>
  </div>
</div>
